import styled, { css } from 'styled-components';
import {
  mq,
  getTextType,
  borderClipPath,
  px2rem,
  getSpace,
  getTransition
} from '../../../stylesheets/tools';

const disabledColor = 'gray';

const StyledSelect = styled.div`
  position: relative;
  height: 100%;
  ${getTextType('subline')}
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;

  .select__wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    ${mq('m')} {
      ${borderClipPath('#000', '#fff')}
      justify-content: center;
      align-items: flex-end;
      flex-direction: row;
    }
  }

  .select__inner {
    position: relative;
    flex-grow: 2;

    ${mq(767, 'max')} {
      ${borderClipPath('#000', '#fff')}
    }
  }

  .select__label {
    position: relative;
    height: 100%;
    top: 10px;
    padding-bottom: 15px;
    margin-left: 20px;
    width: 180px;
    z-index: 1;

    ${mq('m')} {
      top: 0;
      margin: 0;
      padding: ${getSpace('m')} ${getSpace('xxs')} ${getSpace('xxs')} ${getSpace('xxs')};
      border-right: 2px solid black;
    }
  }

  select {
    position: relative;
    width: 100%;
    z-index: 1;
    background: none;
    border: none;
    outline: none;
    appearance: none;
    cursor: pointer;
    padding: ${getSpace('m')} ${getSpace('l')} ${getSpace('xxs')} ${getSpace('xxs')};
    user-select: none;
    color: black;

    &::-ms-expand {
      display: none;
    }

    &::-ms-value,
    &:focus::-ms-value {
      background: none;
      color: inherit;
    }
  }

  .select__icon {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    bottom: 25px;
    width: 50px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    pointer-events: none;
  }

  .select__required {
    font-family: arial-black;
    font-size: ${px2rem('20px')};
    display: inline-block;
    align-self: flex-start;

    ${mq('m')} {
      font-size: ${px2rem('25px')};
    }
  }

  .select__warn {
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    color: red;
    visibility: hidden;
    opacity: 0;
    padding: 10px 20px;
    ${getTransition('inputError')}
  }
  
  ${props =>
    props.error &&
    css`
      .select__wrapper {
        ${mq('m')} {
          ${borderClipPath('red', '#fff')}
        }
      }

      .select__inner {
        ${mq(767, 'max')} {
          ${borderClipPath('red', '#fff')}
        }
      }

      .select__warn {
        visibility: visible;
        opacity: 1;
      }

      .select__inner,
      .select__label {
        border-color: red;
      }
    `}

  ${props =>
    props.active &&
    css`
      .select__wrapper {
        ${mq('m')} {
          ${props.theme.siteTheme &&
            css`
              ${borderClipPath(props.theme.siteTheme.focusColor, '#fff')}
            `}
      }

      .select__inner {
        ${mq(767, 'max')} {
          ${props.theme.siteTheme &&
            css`
              ${borderClipPath(props.theme.siteTheme.focusColor, '#fff')}
            `}
        }
      }

      select,
      .select__label {
        border-color: ${props.theme.siteTheme.focusColor};
      }
    `}

  ${props =>
    props.disabled &&
    css`
      select {
        cursor: not-allowed;
      }

      .select__wrapper {
        ${mq('m')} {
          ${borderClipPath(disabledColor, '#fff')}
        }
      }

      .select__inner {
        ${mq(767, 'max')} {
          ${borderClipPath(disabledColor, '#fff')}
        }
      }

      .select__inner {
        border-color: ${disabledColor};
      }

      .select__label {
        color: ${disabledColor};
      }
    `}

  &.select--standalone {
      width: max-content;

      .select__wrapper {
        flex-direction: column;
        width: max-content;
        background: unset;

        &::after {
          content: unset;
        }
      }

      .select__label {
        border: unset;
        padding-top: 0;
        padding-left: 0;
        margin-right: auto;
        ${getTextType('main')}
      }

      .select__inner {
        width: 100%;
        background: black;
        ${borderClipPath('#000', '#fff')}
        border-radius: 2px;
      }

      .select__inner::after {
        position: absolute;
        content: '';
        inset: 2px 2px 2px 2px;
        ${props => borderClipPath(props.theme.siteTheme.focusColor, '#fff')}
        border-radius: 2px;
        background: #fff;
      }

      select {
        padding: ${getSpace('xs')} ${getSpace('l')} ${getSpace('xxs')} ${getSpace('xs')};
        ${getTextType('subline')}
      }

      .select__icon {
        bottom: 22px;
      }

   ${props =>
     props.error &&
     css`
       .select__inner {
         ${mq('m')} {
           ${borderClipPath('red', '#fff')}
         }
       }

       .select__warn {
         visibility: visible;
         opacity: 1;
         padding-left: 0;
       }

       .select__inner,
       .select__label {
         border-color: red;
       }
     `}

 ${props =>
   props.disabled &&
   css`
     .select__inner {
       ${mq('m')} {
         ${borderClipPath(disabledColor, '#fff')}
       }
     }

     .select__label,
     select {
       color: ${disabledColor};
     }
   `}

  }
`;

export default StyledSelect;
